import { render, staticRenderFns } from "./VxList.vue?vue&type=template&id=426fe271&functional=true"
import script from "./VxList.vue?vue&type=script&lang=js"
export * from "./VxList.vue?vue&type=script&lang=js"
import style0 from "./VxList.vue?vue&type=style&index=0&id=426fe271&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('426fe271')) {
      api.createRecord('426fe271', component.options)
    } else {
      api.rerender('426fe271', component.options)
    }
    module.hot.accept("./VxList.vue?vue&type=template&id=426fe271&functional=true", function () {
      api.rerender('426fe271', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/theme/VxList.vue"
export default component.exports